module.exports = __webpack_public_path__ + "img/seguridad-de-redes-services.99c2e7ba.jpg";